module.exports = __webpack_public_path__ + "img/banner-mobile.4abdbba3.jpg";